<template>
  <div />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'totalUnreadConversations',
    ]),
    titlePrefix() {
      let prefix = '';

      if (this.totalUnreadConversations > 0) {
        prefix = `(${this.totalUnreadConversations}) `;
      }

      return prefix;
    },
  },
  metaInfo() {
    return {
      title: `${this.titlePrefix}Sellia Franchise Chat`,
    };
  },
};
</script>
